import { YhBox } from "@/components/YhBox";
import { NoBillDataTable } from "./NoBillDataTable";
import { Button, message } from "antd";
import { ApplyInvoice } from "../nobill/ApplyInvoice";
import { noBillDataModel } from "./noBillDataModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/FmsResourceAuthEnum";

export const NoBillDataBox = () => {

    const { selectedRowKeys, selectedData, setApplyInvoiceVisible } = noBillDataModel();

    const openApply = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            let flag = 0;
            selectedData.forEach(data => {
                if (data.status != 0) {
                    flag++;
                    message.error(data.tradeCode + ":该账单已申请开票！");
                    return;
                }
            });
            if (flag == 0) {
                setApplyInvoiceVisible(true);
            }
        }
        else {
            message.error("请选择记录!");
        }
    }

    const action = (
        <>
            <div>
                <YhAuth resCode={ResourceAuthEnum.DATA_INVOICE_INVOICING_APPROVE}>
                    <Button
                        className="mr-5"
                        type="link"
                        shape="round"
                        onClick={openApply}
                    >开票审核</Button>
                </YhAuth>
            </div>
        </>
    );

    return (
        <>
            <YhBox title={action}>
                <NoBillDataTable />
            </YhBox>
            <ApplyInvoice />
        </>
    )
}
